module.exports = __webpack_public_path__ + "img/client1.0e90b0ac.png";